export default __webpack_public_path__ + "static/media/TypeScript-Logo.17d5e87e.svg";